/**
 * @file 常量
 */





// 接口请求网络状态
export const networkEnum = (() => {

	const networkSuccess = 'networkSuccess', // 请求成功
		networkError = 'networkError'; // 请求失败
	return {
		[networkSuccess]: networkSuccess,
		[networkError]: networkError
	}
})();





// 单位类型
export const unitType = (() => {
	const ke = 'ke', // 克
		jin = 'jin', // 斤
		kg = 'kg'; // 公斤
	return {
		[ke]: ke,
		[jin]: jin,
		[kg]: kg,
	}
})();



// 商品计量方式 标品 称重
export const goodsMeasuringMethod = (() => {

	const biaopin = 'biaopin', // 标品
		chengzhong = 'chengzhong'; // 称重
	return {
		[biaopin]: biaopin,
		[chengzhong]: chengzhong,
	}
})();




// 默认的全部分类
export const allCategoryItem = {
	id: '',
	name: '全部分类'
}

// 抹零方式
export const molingTypesofEnum = (() => {

	const bumoling = 'bumoling', // 不抹零
		mofen = 'mofen', // 抹分
		mojiao = 'mojiao', // 抹角
		rujiao = 'rujiao', // 四舍五入到角
		jinjiao = 'jinjiao', // 逢分进角
		ruyuan = 'ruyuan'; // 四舍五入到元

	return {
		[bumoling]: bumoling,
		[mofen]: mofen,
		[mojiao]: mojiao,
		[rujiao]: rujiao,
		[jinjiao]: jinjiao,
		[ruyuan]: ruyuan,
	}
})();

// 抹零方式对应的文本
export const molingTypesofTextMap = {
	[molingTypesofEnum.bumoling]: '不抹零',
	[molingTypesofEnum.mofen]: '抹分',
	[molingTypesofEnum.mojiao]: '抹角',
	[molingTypesofEnum.rujiao]: '四舍五入到角',
	[molingTypesofEnum.jinjiao]: '逢分进角',
	// [molingTypesofEnum.ruyuan]: '四舍五入到元'
}



// 整单优惠方式
export const orderDiscountsTypesofEnum = (() => {

	const nodiscountsorder = 'nodiscountsorder', // 无
		changeorderprice = 'changeorderprice', // 整单改价
		discountsorderprice = 'discountsorderprice'; // 折扣优惠

	return {
		[nodiscountsorder]: nodiscountsorder,
		[changeorderprice]: changeorderprice,
		[discountsorderprice]: discountsorderprice
	}
})();







// 称状态
export const scaleStateEnum = (() => {
	const notConnected = 'notConnected', // 未连接
		unStable = 'unStable', // 不稳定
		stable = 'stable'; // 稳定
	return {
		[notConnected]: notConnected,
		[unStable]: unStable,
		[stable]: stable
	}
})();








// 收银台设备小票纸张宽度
export const xiaopiaoPaperWeight = 55;


// 屏幕键盘开启状态
export const keyboardStateEnum = (() => {
	const openState = 'openState', // 开启
		closeState = 'closeState'; // 关闭
	return {
		[openState]: openState,
		[closeState]: closeState
	}
})();



// ai智能识别功能开启状态
export const airecogStateEnum = (() => {
	const airecogOpenState = 'airecogOpenState', // 开启
		airecogCloseState = 'airecogCloseState'; // 关闭
	return {
		[airecogOpenState]: airecogOpenState,
		[airecogCloseState]: airecogCloseState
	}
})();






// 菜单列表数据
export const menuList = (() => {
	return [{
			permissionId: 'cashier',
			name: '收银',
			path: 'cashier',
		},
		{
			permissionId: 'goods',
			name: '商品',
			path: 'commodity',
		},
		{
			permissionId: 'order',
			name: '订单',
			path: 'order',
		},
		{
			permissionId: 'print',
			name: '打印',
			path: 'printd',
		},

		{
			permissionId: 'user',
			name: '会员',
			path: 'member/index',
		},
		{
			permissionId: 'jiaoban',
			name: '交班',
			path: 'shift',
		},
		{
			permissionId: 'statistic',
			name: '报表',
			path: 'report',
		},
		{
			permissionId: 'seting',
			name: '设置',
			path: 'system-set',
		}
	];
})();




/**
 * @description 显示净含量与毛重名称类型
 */
export const showWeightNameEnum = {
	// 净含量
	showWeightNameJhl: 'showWeightNameJhl',

	// 毛重
	showWeightNameMz: 'showWeightNameMz'
}

/**
 * @description 重量(净含量、毛重)名称选择列表
 */
export const weightNameList = [
	{
		id: showWeightNameEnum.showWeightNameJhl,
		name: '净含量'
	},
	{
		id: showWeightNameEnum.showWeightNameMz,
		name: '毛重'
	}
];



// WEBPACK FOOTER //
// ./src/tools/constants.js